import { Injectable } from '@angular/core';
// import { Http ,Headers} from "@angular/http";
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Token } from '../manager/token';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
  })
  export class LogoutService {

  Token;
  TokenCls: Token = new Token(this.router);

  constructor(private http: HttpClient, private router: Router) {

  }

    Logout(data):any {

     return this.http.put(environment.ApiUrl + '/api/logout', data);

    }
  }
